module.exports = __webpack_public_path__ + "img/Crowl-Cabin-1992.051435e3.jpg";